const TRUSTED_PORTAL_SESSION_HEADER = 'trusted-portal-session';

const COMPANION_APPLICATION_ID_HEADER = 'companion-application-id';

export default {
  TRUSTED_PORTAL_SESSION_HEADER,
  COMPANION_APPLICATION_ID_HEADER,
};
